import React from 'react';
import { observer } from 'mobx-react';
import { autorun, observable } from 'mobx';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import { AppUI, ForumUI } from '@seedlang/state';
import styled from '@emotion/styled';
import Breadcrumbs from 'components/breadcrumbs';
import HeaderBar from 'components/header_bar';
import CommentIndex from 'components/comment/comment_index';
import Spinner from 'components/spinner';
import Link from 'components/link';
import { isPresent } from '@seedlang/utils/src';
import GrayButton from 'components/button/gray_button';

const Wrapper = styled.div`

`;

const TopBar = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

const BreadcrumbWrapper = styled.div`
  width: ${props => props.width};
  flex: 1;
`;

const SpinnerWrapper = styled.div`
  margin-top: 40px;
`;

const AdminLink = styled.div`
  margin-top: 5px;
  font-size: 11px;
  text-decoration: underline;
  text-align: center;
  padding: 5px;
`;

@observer
class ForumThreadShow extends React.Component {
  @observable createdEvent = false;
  currentForumThreadId = null;
  markedThreadAsChecked = false;

  constructor(props) {
    super(props);
    this.currentForumThreadId = this.props.params.forumThreadId;
    ForumUI.onReset();
    ForumUI.loadForum(this.props.params.forumId);
    this.loadForumThread();
    this.disposer = autorun(() => {
      if (!this.createdEvent && ForumUI.hasForumThread && ForumUI.hasForum) {
        this.createdEvent = true;
        AppUI.createEvent('discuss - view thread', {forum_title: ForumUI.forum.title, forum_thread_title: ForumUI.forumThread.titleOrTarget});
      }
      this.markThreadAsCheckedIfNeeded();
    });
  }

  componentDidUpdate() {
    if (this.currentForumThreadId !== this.props.params.forumThreadId) {
      this.currentForumThreadId = this.props.params.forumThreadId;
      ForumUI.onReset();
      ForumUI.forumThreadStore.clearShowData();
      this.createdEvent = false;
      this.markedThreadAsChecked = false;
      ForumUI.loadForum(this.props.params.forumId);
      this.loadForumThread();
    }
  }

  componentWillUnmount() {
    ForumUI.forumThreadStore.clearShowData();
    this.disposer && this.disposer();
  }
  loadForumThread = () => {
    ForumUI.loadForumThread(this.props.params.forumThreadId);
  }

  shouldMarkThreadAsChecked = () => {
    const urlParams = new URLSearchParams(this.props.location.search);
    return urlParams.get('mark_thread_as_checked') === 'true';
  }

  clearMarkThreadAsCheckedParam = () => {
    const urlParams = new URLSearchParams(this.props.location.search);
    if (!urlParams.has('mark_thread_as_checked')) {
      return;
    }
    urlParams.delete('mark_thread_as_checked');
    const queryString = urlParams.toString();
    const nextUrl = `${this.props.location.pathname}${queryString ? `?${queryString}` : ''}${this.props.location.hash || ''}`;
    window.history.replaceState(window.history.state, '', nextUrl);
  }

  markThreadAsCheckedIfNeeded = () => {
    if (AppUI.siteIsSeedlang) return;
    if (this.markedThreadAsChecked || !this.shouldMarkThreadAsChecked()) {
      return;
    }
    if (!ForumUI.hasForumThread || !ForumUI.hasForum) {
      return;
    }
    if ((!AppUI.user.admin && !AppUI.user.moderator) || !ForumUI.forum.highlightUnseen || ForumUI.forumThread.seenByAdmin) {
      return;
    }

    this.markedThreadAsChecked = true;
    ForumUI.onToggleSeenByAdmin();
    this.clearMarkThreadAsCheckedParam();
  }

  render() {
    if (ForumUI.hasForumThread) {
      return (
        <Wrapper>
          {
            AppUI.siteIsSeedlang &&
              <HeaderBar
                title='DISCUSS'
                titleRoute='forums.index'
                pageInfo={[
                  {
                    route: 'forums.forum_threads.show',
                    breadcrumbs: [{
                      route: 'forums.show',
                      name: ForumUI.forumStore.showData.title,
                      params: {
                        page: 1,
                        forumId: this.props.params.forumId,
                      },
                    }],
                  },
                ]}
              />
          }
          {
            AppUI.siteIsMemrev && ForumUI.forumThread.worksheet &&
              <TopBar>
                <BreadcrumbWrapper>
                  <Breadcrumbs
                    height='50px'
                    margin='0 0 10px 0'
                    breadcrumbs={[
                      {name: 'All Comments', routeToName: 'creator.worksheet.comments'},
                      {name: ForumUI.forumThread.worksheet.name, routeToName: 'worksheets.show', routeToParams: {worksheetId: ForumUI.forumThread.worksheet.id, groupId: this.props.params.groupId }},
                    ]}
                  />
                </BreadcrumbWrapper>
                {
                  ForumUI.user.anyAdmin &&
                    <Link
                      to={{name: 'creator.worksheets.edit', params: {worksheetId: ForumUI.forumThread.worksheet.id }}}
                    >
                      <GrayButton
                        type='button'
                        style={{height: '20px', marginTop: '10px'}}
                      >
                        Edit Worksheet
                      </GrayButton>
                    </Link>
                }
              </TopBar>
          }
          {
            AppUI.siteIsMemrev && ForumUI.forumThread.exercise && ForumUI.forumThread.exercise.worksheet &&
              <TopBar>
                <BreadcrumbWrapper>
                  <Breadcrumbs
                    height='50px'
                    margin='0 0 10px 0'
                    breadcrumbs={[
                      {name: 'All Comments', routeToName: 'creator.worksheet.comments'},
                      {name: ForumUI.forumThread.exercise.worksheet.name, routeToName: 'worksheets.show', routeToParams: {worksheetId: ForumUI.forumThread.exercise.worksheet.id, groupId: this.props.params.groupId }},
                      {name: ForumUI.forumThread.exercise.name, routeToName: 'worksheets.exercises.show', routeToParams: {exerciseId: ForumUI.forumThread.exercise.id, worksheetId: ForumUI.forumThread.exercise.worksheet.id, groupId: this.props.params.groupId }},
                    ]}
                  />
                </BreadcrumbWrapper>
                {
                  ForumUI.user.anyAdmin &&
                    <Link
                      to={{name: 'creator.exercises.edit', params: {exerciseId: ForumUI.forumThread.exercise.id, worksheetId: ForumUI.forumThread.exercise.worksheet.id }}}
                    >
                      <GrayButton
                        type='button'
                        style={{height: '20px', marginTop: '10px'}}
                      >
                        Edit Exercise
                      </GrayButton>
                    </Link>
                }
              </TopBar>
          }
          <CommentIndex
            hideUserProfile={AppUI.siteIsMemrev}
            groupId={this.props.params.groupId}
            inModal={this.props.inModal}
            post={ForumUI.forumThread}
            showForumThreadPost
            showCommentCount
            user={ForumUI.user}
            commentable={ForumUI.forumThread}
            commentableType='ForumThread'
            forumThreadId={ForumUI.forumThread.id}
            margin='0'
            languageId={ForumUI.forumThread.languageId || AppUI.site.languageId || AppUI.targetLanguageId}
            compactCommentLayout={this.props.inModal}
          />
          {
            AppUI.user.anyAdmin && isPresent(ForumUI.forumThread.sentence) &&
            <AdminLink>
              <Link
                to={{name: 'builder.sentences.edit', params: {sentenceId: ForumUI.forumThread.sentence.id}}}
                target='_blank'
                rel='noopener noreferrer'
              >
                Admin Link
              </Link>
            </AdminLink>
          }
          {
            AppUI.user.anyAdmin && isPresent(ForumUI.forumThread.word) &&
            <AdminLink>
              <Link
                to={{name: 'builder.words.edit', params: {wordId: ForumUI.forumThread.word.id}}}
                target='_blank'
                rel='noopener noreferrer'
              >
                Admin Link
              </Link>
            </AdminLink>
          }
        </Wrapper>
      );
    }
    return (
      <Wrapper>
        <SpinnerWrapper>
          <Spinner />
        </SpinnerWrapper>
      </Wrapper>
    );
  }
}

export default ErrorBoundary(ForumThreadShow);
